import { Capacitor } from "@capacitor/core";

/*
 * Refresh token in an httpOnly cookie (turaq-backend docs/CONTACTS.md «Токены»,
 * server flag AUTH_REFRESH_COOKIE): the site keeps the access token in memory
 * only and never stores the refresh token; /auth/refresh-token reads it from
 * the `turaq_rt` cookie. Off unless VITE_REFRESH_COOKIE=true; the native app
 * always keeps sending refresh_token in the body.
 */
export const refreshCookieMode = import.meta.env.VITE_REFRESH_COOKIE === "true" && !Capacitor.isNativePlatform();
